import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandCircleDownIcon,
      },

      styleOverrides: {
        root: {},
      },
    },
  };
}
